import PartnersMobileDonation from "./PartnersMobileDonation";

export default PartnersMobileDonation;
